
import AppLink from "./AppLink.vue"

export default {
  components: {
    AppLink
  },
  props: {
    image: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getLink() {
      if (this.image.link.linktype === "url" && this.image.link.url) {
        return this.image.link.url
      } else if (
        this.image.link.linktype === "story" &&
        this.image.link.cached_url
      ) {
        return "/" + this.image.link.cached_url
      } else {
        return ""
      }
    }
  }
}
